/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIStoragePosition } from './APIStoragePosition';
import {
    APIStoragePositionFromJSON,
    APIStoragePositionFromJSONTyped,
    APIStoragePositionToJSON,
} from './APIStoragePosition';

/**
 * 
 * @export
 * @interface APIPaginatedStoragePositionList
 */
export interface APIPaginatedStoragePositionList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedStoragePositionList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedStoragePositionList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedStoragePositionList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIStoragePosition>}
     * @memberof APIPaginatedStoragePositionList
     */
    results: Array<APIStoragePosition>;
}

/**
 * Check if a given object implements the APIPaginatedStoragePositionList interface.
 */
export function instanceOfAPIPaginatedStoragePositionList(value: object): value is APIPaginatedStoragePositionList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedStoragePositionListFromJSON(json: any): APIPaginatedStoragePositionList {
    return APIPaginatedStoragePositionListFromJSONTyped(json, false);
}

export function APIPaginatedStoragePositionListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedStoragePositionList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIStoragePositionFromJSON)),
    };
}

export function APIPaginatedStoragePositionListToJSON(value?: APIPaginatedStoragePositionList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIStoragePositionToJSON)),
    };
}

